export default __webpack_public_path__ + "static/media/stake-more-skyrim.f9cc1c80.svg";